import { apiClient } from '@/lib/api/client';

interface ApiData<T> {
  data: T;
}

export interface OnboardingProfileData {
  name: string;
  phone?: string;
  address?: {
    address_line1: string;
    city: string;
    countryIsoCode3: string;
    countryName: string;
    postal_code?: string;
    landmark?: string;
  };
}

export interface OnboardingCompanyData {
  name: string;
  phone?: string;
  email?: string;
  taxId?: string;
  description?: string;
}

export const onboardingService = {
  /**
   * Update seller profile during onboarding
   */
  async updateProfile(data: OnboardingProfileData): Promise<boolean> {
    try {
      await apiClient.put<ApiData<unknown>>('/seller/account/update', {
        name: data.name,
        phone: data.phone,
        address: data.address,
      });
      return true;
    } catch (error) {
      console.error('[Onboarding] Failed to update profile:', error);
      throw error;
    }
  },

  /**
   * Update company during onboarding
   */
  async updateCompany(data: OnboardingCompanyData): Promise<boolean> {
    try {
      await apiClient.put<ApiData<unknown>>('/company/update', {
        name: data.name,
        phone: data.phone,
        email: data.email,
        taxId: data.taxId,
        description: data.description,
      });
      return true;
    } catch (error) {
      console.error('[Onboarding] Failed to update company:', error);
      throw error;
    }
  },

  /**
   * Complete onboarding - marks as done
   */
  async completeOnboarding(): Promise<boolean> {
    try {
      await apiClient.post<ApiData<unknown>>('/seller/onboarding/complete');
      return true;
    } catch {
      // Endpoint may not exist, just return true
      return true;
    }
  },
};
